import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Home/Homepage.css";
import "./AllOpenOrdersPage.css";

const STATIC_POSITIONS = [
  { _id: "fp001xyz", user_id: "user_101", pair_id: { short_name: "BTC/USDT" }, side: "LONG", quantity: 0.05, totalLongQty: 0.05, totalShortQty: 0, entryPrice: 67200, entry_price: 67200, exit_price: null, leverage: 10, unrealizedPnl: 125.50, realizedPnl: 0, status: "Open", createdAt: "2025-02-17T14:30:00.000Z", closed_at: null },
  { _id: "fp002abc", user_id: "user_202", pair_id: { short_name: "ETH/USDT" }, side: "SHORT", quantity: 3, totalLongQty: 0, totalShortQty: 3, entryPrice: 3520, entry_price: 3520, exit_price: null, leverage: 20, unrealizedPnl: -45.20, realizedPnl: 0, status: "Open", createdAt: "2025-02-18T09:00:00.000Z", closed_at: null },
  { _id: "fp003def", user_id: "user_303", pair_id: { short_name: "SOL/USDT" }, side: "LONG", quantity: 100, totalLongQty: 100, totalShortQty: 0, entryPrice: 142.5, entry_price: 142.5, exit_price: 148.2, leverage: 5, unrealizedPnl: 0, realizedPnl: 570, status: "Closed", createdAt: "2025-02-16T11:20:00.000Z", closed_at: "2025-02-18T10:15:00.000Z" },
  { _id: "fp004ghi", user_id: "user_101", pair_id: { short_name: "DOGE/USDT" }, side: "LONG", quantity: 5000, totalLongQty: 5000, totalShortQty: 0, entryPrice: 0.085, entry_price: 0.085, exit_price: null, leverage: 50, unrealizedPnl: 32.75, realizedPnl: 0, status: "Open", createdAt: "2025-02-18T07:30:00.000Z", closed_at: null },
  { _id: "fp005jkl", user_id: "user_404", pair_id: { short_name: "AVAX/USDT" }, side: "SHORT", quantity: 20, totalLongQty: 0, totalShortQty: 20, entryPrice: 38.5, entry_price: 38.5, exit_price: null, leverage: 10, unrealizedPnl: -12.40, realizedPnl: 0, status: "Open", createdAt: "2025-02-18T11:00:00.000Z", closed_at: null },
];

const FuturesPositionsPage = () => {
  const [positions] = useState(STATIC_POSITIONS);
  const [search, setSearch] = useState("");
  const [loading] = useState(false);

  const formatDate = (iso) => {
    if (!iso) return "—";
    try {
      const d = new Date(iso);
      return d.toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return iso;
    }
  };

  const formatNum = (n) =>
    n != null && !Number.isNaN(Number(n))
      ? Number(n).toLocaleString("en-IN", { maximumFractionDigits: 10 })
      : "—";

  const filtered = positions.filter(
    (o) =>
      o._id?.toLowerCase().includes(search.toLowerCase()) ||
      o.user_id?.toLowerCase().includes(search.toLowerCase()) ||
      (o.pair_id?.short_name || o.symbol || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Futures Trading</span>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Futures Positions</span>
          </p>
          <h1 className="dashboard-hero__title">Futures Positions</h1>
          <p className="dashboard-hero__subtitle">
            View all open and closed futures positions
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-bullseye" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="openorders-section">
          <div className="openorders-section__header">
            <div className="openorders-section__title-wrap">
              <span className="openorders-section__icon">
                <i className="fas fa-bullseye" />
              </span>
              <h2 className="openorders-section__title">Futures Positions</h2>
            </div>
            <div className="openorders-section__stats">
              <span className="openorders-stat">
                <strong>{positions.length}</strong> Total
              </span>
            </div>
          </div>
          <div className="openorders-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by position ID, user ID or pair..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="openorders-search-input"
            />
          </div>
          {loading ? (
            <div className="openorders-empty">
              <i className="fas fa-spinner fa-spin" /> Loading…
            </div>
          ) : filtered.length > 0 ? (
            <div className="openorders-table-wrap">
              <table className="openorders-table">
                <thead>
                  <tr>
                    <th>Position ID</th>
                    <th>User ID</th>
                    <th>Pair</th>
                    <th>Side</th>
                    <th>Size</th>
                    <th>Entry</th>
                    <th>Exit</th>
                    <th>Lev</th>
                    <th>Unrealized PnL</th>
                    <th>Realized PnL</th>
                    <th>Status</th>
                    <th>Opened</th>
                    <th>Closed</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((row) => (
                    <tr key={row._id}>
                      <td><span className="openorders-order-id">{row._id?.slice(-8)}</span></td>
                      <td><span className="openorders-order-id">{row.user_id}</span></td>
                      <td><strong>{row.pair_id?.short_name || row.symbol || "—"}</strong></td>
                      <td>
                        <span className={`openorders-side openorders-side--${(row.side || "").toLowerCase()}`}>
                          {row.side ?? "—"}
                        </span>
                      </td>
                      <td>{formatNum(row.quantity || (row.side === "LONG" ? row.totalLongQty : row.totalShortQty))}</td>
                      <td>{formatNum(row.entryPrice ?? row.entry_price)}</td>
                      <td>{formatNum(row.exit_price)}</td>
                      <td>{row.leverage ?? "—"}</td>
                      <td>
                        <span className={Number(row.unrealizedPnl) >= 0 ? "text-green" : "text-red"}>
                          {formatNum(row.unrealizedPnl)}
                        </span>
                      </td>
                      <td>
                        <span className={Number(row.realizedPnl) >= 0 ? "text-green" : "text-red"}>
                          {formatNum(row.realizedPnl)}
                        </span>
                      </td>
                      <td>{row.status ?? "—"}</td>
                      <td>{formatDate(row.createdAt)}</td>
                      <td>{formatDate(row.closed_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="openorders-empty">
              {positions.length === 0
                ? "No futures positions. Connect your admin API to fetch data."
                : "No positions match your search."}
            </p>
          )}
        </section>
      </div>
    </main>
  );
};

export default FuturesPositionsPage;
